/**
 * LE NOM DU FICHIER de l'image d'un graphe (DEV-1508 lot 4, item 24).
 *
 * Le bouton appareil photo de la barre d'outils télécharge une image. Ce fichier
 * atterrit dans le dossier de téléchargements du client : c'est une surface
 * qu'il voit, au même titre qu'un libellé à l'écran. Deux règles s'y appliquent.
 *
 *  • Il doit DIRE ce qu'il contient : la page, le numéro du point, la grandeur.
 *    `newplot.png`, le défaut de Plotly, ne dit rien et se collisionne avec tous
 *    les autres graphes déjà téléchargés.
 *
 *  • Il ne porte AUCUN mot interne : pas de nom de société, pas de nom de
 *    service, pas de clé technique de série. Ce qui compose la partie « grandeur »
 *    est le LIBELLÉ de l'onglet, celui que le client lit, seulement mis en
 *    minuscules et débarrassé de ses accents pour tenir dans un nom de fichier.
 */

/**
 * Un segment de nom de fichier à partir d'un libellé montré à l'écran :
 * minuscules, accents retirés, tout ce qui n'est ni lettre ni chiffre devenant
 * un tiret, sans tiret en tête ni en queue.
 *
 * « Énergie » donne `energie`, « Durée de dépassement » donne
 * `duree-de-depassement`.
 */
export function assainirSegmentDeNomDeFichier(libelle: string): string {
    return libelle
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
}

/**
 * Le nom complet, sans extension : `donnees-compteur-<point>-<grandeur>`.
 *
 * Sans numéro de point (une maquette, un récit), le nom se resserre plutôt que
 * de laisser un tiret orphelin qui se lirait comme un champ vide.
 */
export function nomDuFichierDeGraphe(
    prm: string | null | undefined,
    cleOngletLisible: string
): string {
    const morceaux = ["donnees-compteur"]
    if (prm) morceaux.push(assainirSegmentDeNomDeFichier(prm))
    const grandeur = assainirSegmentDeNomDeFichier(cleOngletLisible)
    if (grandeur) morceaux.push(grandeur)
    return morceaux.join("-")
}
